import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Row from 'ravenjs/lib/Row';
import Typography from 'ravenjs/lib/Typography';
import { formatNumberWithDelimiter } from 'ravenjs/utils/number';
import { themeGet } from 'ravenjs/utils/theme';

const PaginationTotalRowsStyled = styled(Row)`
    ${themeGet('PaginationTotalRows.styles')};
`;

const PaginationTotalRowsV2 = ({ totalRows, label }) => {
    const total = formatNumberWithDelimiter(totalRows || 0);
    return (
        <PaginationTotalRowsStyled
            alignItems="center"
            gutter={false}
            justify="flex-start"
            width="auto"
        >
            <Typography
                color="text"
                fontSize="0.75rem"
                fontFamily="RobotoMono"
                gutterBottom="0"
                gutterRight="4px"
                gutterTop="0"
                type="paginationLabel"
            >
                {label}: {total}
            </Typography>
        </PaginationTotalRowsStyled>
    );
};

PaginationTotalRowsV2.propTypes = {
    totalRows: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
};

export default PaginationTotalRowsV2;
